import makeStyles from '@mui/styles/makeStyles';
import { fonts, colors } from '../../../theme';

export const useStyles = makeStyles((theme) => ({
  regionRoot: {
    marginInline: '2vw',
  },
  dFlex: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  dFlexIcon: {
    display: 'flex',
    justifyContent: 'end',
    '& .MuiFormControl-root': {
      margin: 0,
    },
  },
  deactiveCheckbox: {
    '@media (min-width: 1200px)': {
      height: '4vw',
    },
    '& .MuiFormControl-root:first-child': {
      margin: '1vw',
      minWidth: '3vw',
      marginRight: '-3.5vw',
      '& .MuiFormControlLabel-labelPlacementEnd': {
        marginBottom: '-3vw',
      },
    },
    textAlign: 'inherit',
  },
  dialogButtons: {
    justifyContent: 'flex-end',
    padding: '0 10px',
    '& .MuiButton-root': {
      '@media (min-width: 1200px)': {
        minWidth: '10vw !important',
        height: '2.7vw !important',
        fontSize: '0.8vw',
      },
    },
  },
  popupButton: {
    display: 'flex',
    justifyContent: 'end',
    '& .MuiButtonBase-root.MuiButton-root': {
      '@media (min-width: 1200px)': {
        height: '3vw !important',
        minWidth: '9vw !important',
      },
      marginRight: '15px',
      borderRadius: '4px',
      marginTop: '20px',
    },
  },
  leftContent: {
    display: 'flex',
    alignItems: 'center',
  },
  titleRow: {
    justifyContent: 'space-between',
    marginTop: '0.9vw',
  },
  headerTitle: {
    fontWeight: fonts.fontWeight.bold,
    fontSize: '1.5vw',
    padding: '10px 10px 10px 1px',
    [theme.breakpoints.down('md')]: {
      fontSize: 16,
    },
  },
  addbutton: {
    minWidth: '7.5vw  !important',
  },
  regionManagerContainer: {
    color: colors.black,
    width: 'auto',
    fontFamily: fonts.fontType.roboto,
    marginTop: '0.5vw',
  },
  regionManagerList: {
    textAlign: 'center',
    paddingBottom: 50,
  },
  tableView: {
    width: '100%',
  },
  addIconSize: {
    width: '2vw',
    height: '1.4vw',
    [theme.breakpoints.down('md')]: {
      width: 16,
      height: 16,
    },
  },
}));

export default {
  useStyles,
};
